// PropertyDataForm.tsx (updated)
import React from "react";
import ValuationForm from "./valuation-form/ValuationForm";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import { transformFromPayload } from "@/utils/transform-from-payload"; // You'll need to create this

interface PropertyDataFormProps {
  isForm: boolean;
  propertyId?: string;
}

const PropertyDataForm: React.FC<PropertyDataFormProps> = ({
  propertyId,
  isForm,
}) => {
  const { id } = useParams<{ id: string }>();
  
  const { data: property, isLoading } = useQuery({
    queryKey: ["properties", id],
    enabled: !!id,
    queryFn: async () => {
      const response = await apiRequest("GET", `/properties/${id}`);
      return response.json();
    },
  });

  // Transform the API response to match your form structure
  const formData = property?.data 
    ? transformFromPayload(property.data) // Create this transformer
    : undefined;

    console.log("Transformed form data:", formData);

  return (
    <ValuationForm
      property={formData} // Pass transformed data
      isLoading={isLoading}
    />
  );
};

export default PropertyDataForm;

